import React, { FC } from "react";

import { OverviewCarouselModel } from "../../models/OverviewCarousel.model";
import { TOverviewCarouselProps } from "../../types/OverviewCarousel.type";
import Carousel from './carousel';
import Video from './video';
import "./styles.scss";

const OverviewCarousel: FC<TOverviewCarouselProps> = (props) => {
  const model = new OverviewCarouselModel(props);

  return (
    <>
      {
      // model.video ?
      //   <Video {...props} /> :
        model.slides ?
        <Carousel {...props} /> :
        null
      }
    </>
  )
};

export default OverviewCarousel;
